module.exports = __webpack_public_path__ + "static/img/banner-about.adfb989.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/banner-about.jpg
// module id = 07wV
// module chunks = 0